export default {
  imagePath: (path) => {
    return `/images/${path}`
  }
}



// WEBPACK FOOTER //
// ./src/helpers/AssetHelpers.js